export const QUICK_ACCESS_MAX_SLOTS = 4;

export const QUICK_ACCESS_MAX_RECENTS = 5;

export const QUICK_ACCESS_STORAGE_PREFIX = 'veiling:quickaccess';

export enum QuickAccessStorageBucket {
  Pins = 'pins',
  Recents = 'recents',
}

export const QUICK_ACCESS_DEFAULT_KEYS: string[] = ['sales-statement', 'gfp2', 'stock', 'order'];
